<template>
  <div
    v-tooltip="$t('OFFER_CUSTOMISATION.ADD_SECTION')"
    class="flex h-10 w-10 cursor-pointer items-center space-x-1 rounded-sm border border-gray-200 bg-white px-2 text-gray-500 hover:border-gray-300"
    @click="addGroup"
  >
    <icon-base
      :icon="IconPlusNoColor"
      class="-mt-3 -ml-1.5"
      height="25"
      width="25"
      view-box="0 0 50 50"
    />
  </div>
</template>
<script setup lang="ts">
import { nextTick } from "vue";

import IconPlusNoColor from "@/components/icons/IconPlusNoColor.vue";

const emit = defineEmits<{
  addNewGroup: [void];
}>();

const addGroup = async () => {
  emit("addNewGroup");
  await nextTick();
  const modal = document.getElementById("offer-fields-modal");
  if (modal) {
    modal.scrollTop = modal.scrollHeight;
  }
};
</script>
